import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

const Table = ({
  headerContainerClass = '',
  tableHeaders = [],
  tableBody = null,
  tableBodyClass = ''
}) => {
  return (
    <div className="table-component">
      <div className="table-head">
        <div className={`flex header-row ${headerContainerClass || 'space-between'}`}>
          {
            map(tableHeaders, header => (
              <div className={`label ${header.classname || ''}`} key={header.label}>
                {header.label}
              </div>
            ))
          }
        </div>
      </div>

      <div className={`table-body ${tableBodyClass}`}>
        {tableBody}
      </div>
    </div>
  );
};

Table.propTypes = {
  headerContainerClass: PropTypes.string,
  tableHeaders: PropTypes.array,
  tableBody: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ]),
  tableBodyClass: PropTypes.string
};

export default Table;
